import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { Field, reduxForm, Form } from 'redux-form';
import Button from 'material-ui/Button';

import renderTextField from '../helpers/RenderTextFiledWithDiv';
import validationHelper from '../helpers/ValidationHelper';
import autotecStyle from '../components/Styles/style';

const validate = (values) => {
  const errors = validationHelper.validateRequired(['oldPassword', 'newPassword', 'confirmPassword'], values);
  const pwdEmptyError = 'Old Password must not be empty.';
  const pwdMatchError = 'New password must be different than old password.';
  const pwdMismatchError = 'Passwords must match.';
  const pwdLengthError = 'Password must be between 16 and 25 characters in length.';
  const pwdCharFormatError = 'Password must include at least 1 uppercase character.';
  const pwdNumFormatError = 'Password must include at least 1 numerical.';
  const pwdSpecialCharError = "Password must include at least 1 special character(@$!%*?&).";
  const pwdTotalError =
      <div> { pwdLengthError } <br /> { pwdCharFormatError } <br /> { pwdNumFormatError } <br /> { pwdSpecialCharError } </div>;

  const re  = /[\d]{1,21}/g;
  const re1 = /[a-z]{1,21}/g;
  const re2 = /[A-Z]{1,21}/g;
  const re3 = /[@$!%*?&]{1,21}/g;
  const re4 = /^[\S]{16,25}$/;

  if (values.newPassword && values.newPassword.length > 0){
    if (values.oldPassword && values.oldPassword.length > 0) {
      if (values.newPassword === values.oldPassword) {
        errors.newPassword = pwdMatchError;
      } else if (values.newPassword.length < 16) {
        errors.newPassword = pwdTotalError;
      } else if (values.newPassword.length >= 16) {
        if (!re.test(values.newPassword) || !re1.test(values.newPassword) || !re2.test(values.newPassword)
            || !re3.test(values.newPassword) || !re4.test(values.newPassword)) {
          errors.newPassword = pwdTotalError;
        }
      }
    } else {
      errors.oldPassword = pwdEmptyError;
      if (values.newPassword.length < 16) {
        errors.newPassword = pwdTotalError;
      } else if (values.newPassword.length >= 16) {
        if (!re.test(values.newPassword) || !re1.test(values.newPassword) || !re2.test(values.newPassword)
            || !re3.test(values.newPassword) || !re4.test(values.newPassword)) {
          errors.newPassword = pwdTotalError;
        }
      }
    }
  }

  if (values.newPassword && values.confirmPassword) {
    if (values.newPassword !== values.confirmPassword) {
      errors.newPassword = pwdMismatchError;
      errors.confirmPassword = pwdMismatchError; // errors are not showing for some reason
    }
    if (!values.oldPassword || values.oldPassword.length <= 0) {
      errors.oldPassword = pwdEmptyError;
    }
  }
  return errors;
};

const PasswordForm = props =>
    (<Form key="PasswordForm" onSubmit={props.handleSubmit(props.handleSave)}>
      <Field name="oldPassword" component={renderTextField} label="Old Password" className={props.classes.textField} divClassName={props.classes.marginStyle} password />
      <Field name="newPassword" component={renderTextField} label="New Password" className={props.classes.textField} divClassName={props.classes.marginStyle} password />
      <Field name="confirmPassword" component={renderTextField} label="Confirm Password" className={props.classes.textField} divClassName={props.classes.marginStyle} password />
      <Button variant="raised" color="primary" type="submit" className={props.classes.buttonStyle}>Save</Button>
    </Form>);

PasswordForm.propTypes = {
  classes: PropTypes.shape().isRequired
};

export default withStyles(autotecStyle, { withTheme: true })(reduxForm({ form: 'PasswordForm', validate })(PasswordForm));


// WEBPACK FOOTER //
// ./src/containers/PasswordForm.js